import { render, staticRenderFns } from "./UpdateSafePoint.vue?vue&type=template&id=2301d10e&scoped=true&"
import script from "./UpdateSafePoint.vue?vue&type=script&lang=js&"
export * from "./UpdateSafePoint.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSafePoint.vue?vue&type=style&index=0&id=2301d10e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2301d10e",
  null
  
)

export default component.exports